import styles from './footer.module.css'
import clsx from 'clsx'
import React from 'react'
type Props = {
  children: React.ReactNode
  inline?: boolean
}

const PageContainerFooter = ({ children, inline }: Props): React.ReactNode => {
  return (
    <div
      className={clsx(styles.footer, {
        [styles.compact]: inline,
      })}
    >
      {children}
    </div>
  )
}

export default PageContainerFooter
